<template>
    <div class="pd20x flex1">
      <Loading v-if="loading"></Loading>
      <addQuestionVipBank :visible="visible" @close="visible = false" :data="currentItem" :type="currentType" @update="getData"></addQuestionVipBank>
      <div class="h100pct ofA">
        <div class="filter pd20x mb10x">
          <div>
            科目名称 : {{name}}
          </div>
          <div style="display: flex; gap: 10px; margin-top: 10px;">
            <a-select v-model="downEnroll" style="width: 200px" @change="handleChange" placeholder="请选择题型">
                  <a-select-opt-group v-for="(group, groupKey) in questionTypeGroups" :key="groupKey" :label="group.label">
                    <a-select-option 
                        v-for="(label, value) in group.types" 
                        :key="value" 
                        :value="value"
                    >
                        {{ label }}
                    </a-select-option>
                  </a-select-opt-group>
              </a-select>
              <a-button type="primary" @click="showGroupPaperModal">组卷</a-button>
          </div>
        </div>
        <!-- 组卷模态框 -->
        <a-modal
          title="组卷设置"
          :visible="groupPaperModalVisible"
          width="900px"
          @cancel="groupPaperModalVisible = false"
          @ok="saveGroupPaperSettings"
        >
          <div style="max-height: 500px; overflow-y: auto;">
            <div v-for="(paper, index) in papersData" :key="'paper-' + index" style="margin-bottom: 20px; padding: 15px; border: 1px solid #e8e8e8; border-radius: 4px;">
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 15px;">
                <h3 style="margin-top: 0; margin-bottom: 0;">第{{index + 1}}套卷子</h3>
                <div style="display: flex; gap: 10px;">
                  <a-button v-if="index === 0" type="primary" size="small" @click="addNewPaper">添加组卷</a-button>
                  <a-button v-if="papersData.length > 1 && index !== 0" type="danger" size="small" @click="removePaper(index)">删除组卷</a-button>
                </div>
              </div>
              <div v-for="(config, configIndex) in paper.configs" :key="'config-' + configIndex" style="margin-bottom: 10px;">
                <a-form layout="inline">
                  <a-form-item label="组卷题型:">
                    <a-select v-model="config.questionType" :options="questionTypeOptions" placeholder="选择题型" style="width: 150px"></a-select>
                  </a-form-item>
                  <a-form-item label="来源题型:">
                    <a-select v-model="config.fromQuestionType" :options="questionTypeOptions" placeholder="来源题型" style="width: 150px"></a-select>
                  </a-form-item>
                  <a-form-item label="来源组号:">
                    <a-select v-model="config.groupNumber" :options="groupOptions" placeholder="来源组号" style="width: 150px"></a-select>
                  </a-form-item>
                  <a-form-item>
                    <a-button type="link" @click="addPaperConfig(index)">+</a-button>
                    <a-button v-if="paper.configs.length > 1" type="link" danger @click="removePaperConfig(index, configIndex)">-</a-button>
                  </a-form-item>
                </a-form>
              </div>
            </div>
          </div>
          
          <!-- PDF上传功能 -->
          <div style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #e8e8e8;">
            <h3 style="margin-top: 0; margin-bottom: 20px;">资料上传</h3>
            
            <!-- 左右两列布局 -->
            <div style="display: flex; gap: 40px;">
              <!-- 考试大纲上传 -->
              <div style="flex: 1;">
                <a-form-item label="考试大纲:">
                   <a-upload
                      name="ks_file"
                      :accept="'.PDF'"
                      list-type="picture"
                      @change="handleFileChange"
                      :customRequest="customRequestDetail"
                      :fileList='syllabusFileList'
                  >
                    <a-button> <a-icon type="upload" />上传考试大纲</a-button>
                  </a-upload>
                </a-form-item>
              </div>
              
              <!-- 斩题精华上传 -->
              <div style="flex: 1;">
                <a-form-item label="斩题精华:">
                  <a-upload
                    name="file"
                    :accept="'.PDF'"
                    list-type="picture"
                    @change="handleEssenceChange"
                    :customRequest="customRequestEssence"
                    :fileList="essenceFileList"
                  >
                    <a-button> <a-icon type="upload" />上传斩题精华</a-button>
                  </a-upload>
                </a-form-item>
              </div>
            </div>
          </div>
        </a-modal>
        <a-table
            :columns="columns"
            :data-source="result"
            :pagination="pagination"
            :scroll="{ x: 1300 }"
            :rowKey="'id'"
            @change="changePage"
        >
          <template v-for="(col, i) in ['consult', 'name']" :slot="col" slot-scope="text">
            <div :key="col" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
              <a-tooltip>
                <template slot="title">
                  {{ text }}
                </template>
                {{ text }}
              </a-tooltip>
            </div>
          </template>
          <template slot="status" slot-scope="text, record">
            <div v-if="record.status == 1">正常</div>
            <div v-if="record.status == 2" style="color: red">隐藏</div>
          </template>
          <template slot="groupNumber" slot-scope="text, record">
            <a-select v-model="record.group_number" style="width: 80px" @change="updateQuestionGroup(record.id, $event)">
              <a-select-option v-for="option in groupOptions" :key="option.value" :value="option.value">
                {{ option.label }}
              </a-select-option>
            </a-select>
          </template>
          <template slot="operation" slot-scope="text, record">
            <a-space>
              <a-button type="primary" ghost style="margin-right:10px" @click="editItem(record)">修改</a-button>
              <a-button type="primary" ghost style="margin-right:10px" @click="deleteItem(record.id)">删除</a-button>
            </a-space>
          </template>
        </a-table>
      </div>
    </div>
  </template>
  <script>
  const columns = [
    {
      title: '试题类型',
      dataIndex: 'typeName',
      scopedSlots: { customRender: 'typeName' },
      width: 120,
      align:'center'
    },
    {
      title: '组号',
      dataIndex: 'group_number',
      width: 80,
      align:'center',
      scopedSlots: { customRender: 'groupNumber' }
    },{
      title: '题目',
      dataIndex: 'title',
      scopedSlots: { customRender: 'name' },
      width: 200,
      align:'center'
    },{
      title: '答案',
      dataIndex: 'consult',
      scopedSlots: { customRender: 'consult' },
      width: 200,
      align:'center'
    },{
      title: '状态',
      dataIndex: 'status',
      scopedSlots: { customRender: 'status' },
      width: 100,
      align:'center'
    }, {
      title: '操作',
      width: 140,
      dataIndex: 'operation',
      scopedSlots: { customRender: 'operation' },
    },
  ];
  import * as http from '@/libs/analysis'
  import { getVipQuestionList, deleteVipQuestion, initVipPaperConfig, getVipPaperConfig, updateVipQuestionGroup, batchUpdateVipPaperConfig } from '@/libs/api'
  import { uploadImg } from '@/libs/api'
  import addQuestionVipBank from '@/components/analysis/addQuestionVipBank'
  import Loading from '@/components/loading'
  import moment from 'moment'
  export default {
    name: 'questionBank',
    components: {  Loading, addQuestionVipBank },
    data(){
      return{
        downEnroll: '添加单题',
        bookName: '',
        bookList: [],
        result: [],
        columns,
        visible: false,
        groupPaperModalVisible: false,
        loading: true,
        currentType: 'single_choice',
        currentItem: [],
        name: '',
        classId : '',
        bookId: 0,
        total: 0,
        filter:{
          cate_id: 0,
          keywords:''
        },
        pagination:{
          page: 1,
          size: '15',
          pageSize: 15
        },
        colorList: ['pink', 'red', 'orange', 'green', 'cyan', 'blue', 'purple'],
        // 组卷相关数据
        papersData: [{ configs: [{ questionType: '', groupNumber: '', questionNumber: '' }] }], // 初始化为1套卷子
        // PDF上传相关数据
        syllabusFileList: [],
        essenceFileList: [],
        syllabusLoading: false,
        essenceLoading: false,
        pdfFiles: {
          exam_syllabus: '',
          exam_syllabus_name: '',
          question_essence: '',
          question_essence_name: ''
        },
        questionTypeOptions: [], // 所有可用题型选项
        groupOptions: Array.from({length: 100}, (_, i) => ({value: i + 1, label: `第${i + 1}组`})),
        questionTypeGroups: [
          {
            label: '基本题型',
            types: {
              'single_choice': '单选题',
              'multiple_choice': '多选题',
              'fill': '填空题',
              'jud_question': '判断题'
            }
          },
          {
            label: '问答题型',
            types: {
              'mcjst': '名词解释',
              'cyjst': '词语解释题',
              'zwt': '作文题',
              'jxt': '简析题',
              'zmt': '证明题',
              'zhq': '综合题',
              'wdt': '问答题',
              'ypt': '应用题',
              'jst': '计算题',
              'lst': '论述题',
              'fxsmt': '分析说明题',
              'clt': '材料题',
              'clfxt': '材料分析题',
              'fxt': '分析题',
              'alfxt': '案例分析题',
              'alt': '案例题',
              'czt': '操作题',
              'gct': '改错题',
              'jdjst': '简单计算题',
              'jsfxt': '计算分析题',
              'ywhst': '业务核算题',
              'zhyyt': '综合应用题',
              'gwbst': '古文背诵题',
              'sct': '释词题',
              'gwfyt': '古文翻译题',
              'gwbdt': '古文标点题',
              'gwydt': '古文阅读题',
              'xzzt': '写作主题',
              'xzft': '写作辅题',
              'dzw': '大作文',
              'xzw': '小作文',
              'ydfxt': '阅读分析题',
              'ydljt': '阅读理解',
              'ydpj': '阅读判断'
            }
          }
        ]
      }
    },
    mounted(){
      if (this.$route.query.bind_catid)
        this.filter.cate_id = this.$route.query.bind_catid;
      if (this.$route.query.name)
        this.name = this.$route.query.name;
      
      // 初始化组卷相关数据
      this.initQuestionTypeOptions();
      this.initPapersData();
      
      this.$nextTick(()=>{
        this.getData()
      })
    },
    methods:{
      moment,
      // 初始化组卷数据
      initPapersData() {
        this.papersData = [{ configs: [{ questionType: '', groupNumber: '', questionNumber: '' }] }]; // 初始化为1套卷子
      },
      
      // 动态添加新组卷
      addNewPaper() {
        this.papersData.push({
          configs: [{ questionType: '', groupNumber: '', questionNumber: '' }]
        });
      },
      
      // 删除组卷
      removePaper(index) {
        if (this.papersData.length > 1) {
          this.papersData.splice(index, 1);
        }
      },
      forceRefresh() {
        console.log('强制刷新数据');
        // 重新加载数据
        this.loadPapersData();
      },
      // 从后端加载组卷配置
      async loadPapersData() {
        this.loading = true;
        try {
          const res = await getVipPaperConfig({ cate_id: this.filter.cate_id });
          console.log('接口返回的原始数据:', res);
          if (res && res.configs && Array.isArray(res.configs)) {
            res.configs.forEach(paper => {
              const paperIndex = paper.paper_index - 1;
              // 确保paperIndex在有效范围内，并且papersData[paperIndex]存在
              if (paperIndex >= 0) {
                let configs = [{
                  questionType: '',
                  groupNumber: '',
                  questionNumber: '',
                }];
                // 处理 config_data 可能不存在或为空的情况
                if (paper.config_data && paper.config_data.config_data && paper.config_data.config_data.length > 0) {
                  configs = paper.config_data.config_data;
                }
                
                // 确保papersData[paperIndex]存在
                if (!this.papersData[paperIndex]) {
                  this.papersData[paperIndex] = { configs: [] };
                }
                
                // 使用 Vue.set 确保响应式更新
                this.$set(this.papersData[paperIndex], 'configs', [...configs]);
              }
            });
          }

          // 初始化上传PDF的展示与默认值
          if (res && res.pdfFiles) {
            this.pdfFiles = {
              exam_syllabus: res.pdfFiles.exam_syllabus || '',
              exam_syllabus_name: res.pdfFiles.exam_syllabus_name || '',
              question_essence: res.pdfFiles.question_essence || '',
              question_essence_name: res.pdfFiles.question_essence_name || ''
            };

            // 更新考试大纲文件列表
            if (res.pdfFiles.exam_syllabus) {
              this.syllabusFileList = [{
                    uid: '1',
                    name: res.pdfFiles.exam_syllabus_name,
                    status: 'done',
                    url: res.pdfFiles.exam_syllabus,
              }]
            } else {
              this.syllabusFileList = [];
            }

            // 更新斩题精华文件列表
            if (res.pdfFiles.question_essence) {
              this.essenceFileList = [{
                    uid: '1',
                    name: res.pdfFiles.question_essence_name,
                    status: 'done',
                    url: res.pdfFiles.question_essence,
              }];
            } else {
              this.essenceFileList = [];
            }
          }
          console.log(this.syllabusFileList)
          console.log('更新后的 papersData:', this.papersData);
          
        } catch (error) {
          console.error('加载组卷配置失败:', error);
          // 初始化空配置
          this.initPapersData();
        } finally {
          this.loading = false;
          
          // 在下一个 tick 强制更新
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      },
      
      // 初始化VIP组卷配置
      initVipPaperConfigs() {
        initVipPaperConfig({ 
          cate_id: this.filter.cate_id,
          configs: this.papersData.map(paper => paper.configs)
        })
          .then(res => {
            if (res.code !== 0) {
              console.log('初始化组卷配置失败:', res.msg);
            }
          })
          .catch(error => {
            console.log('初始化组卷配置失败:', error);
          });
      },
      
      // 初始化题型选项
      initQuestionTypeOptions() {
        this.questionTypeOptions = [];
        this.questionTypeGroups.forEach(group => {
          Object.entries(group.types).forEach(([value, label]) => {
            this.questionTypeOptions.push({ value, label });
          });
        });
      },
      
      // 显示组卷模态框 - 点击时拉取最新的组卷信息
      async showGroupPaperModal() {
        // 显示加载状态
        this.loading = true;
        // 首先加载最新的组卷配置
        await this.loadPapersData();
        // 然后显示模态框
        this.groupPaperModalVisible = true;
      },
      
      // 添加卷子配置
      addPaperConfig(paperIndex) {
        this.papersData[paperIndex].configs.push({ questionType: '', groupNumber: '' });
      },
      
      // 移除卷子配置
      removePaperConfig(paperIndex, configIndex) {
        if (this.papersData[paperIndex].configs.length > 1) {
          this.papersData[paperIndex].configs.splice(configIndex, 1);
        }
      },
      
      // 保存组卷设置
      saveGroupPaperSettings() {
        const configs = this.papersData.map((paper, index) => ({
          paper_index: index + 1, // 转换为1-based索引
          config_data: paper.configs.filter(config => 
            config.questionType && config.groupNumber && config.fromQuestionType
          )
        }));

        console.log('准备保存的配置:', JSON.stringify(configs, null, 2));

        // 调用保存接口
        // 包含PDF文件信息
        const saveData = {
          cate_id: this.filter.cate_id,
          configs: configs,
          pdf_files: this.pdfFiles
        };
        
        console.log('准备保存的完整数据:', JSON.stringify(saveData, null, 2));
        
        batchUpdateVipPaperConfig(saveData)
          .then(res => {
            this.$message.success('组卷设置保存成功！');
            this.groupPaperModalVisible = false;
          })
          .catch(error => {
            console.error('保存组卷配置失败:', error);
            this.$message.error('保存失败，请稍后重试');
          });
        },  
      
      // 更新题目组号
      updateQuestionGroup(id, groupNumber) {
        updateVipQuestionGroup({ id, groupNumber })
          .then(res => {
            this.$message.success('组号更新成功！');
          })
          .catch(error => {
            console.error('更新组号失败:', error);
            this.$message.error('更新失败，请稍后重试');
          });
      },
      showPapers() {
        console.log(this.bookId)
        this.$router.push({path:'/analysis/showPaper', query: { bookId:this.bookId, name: this.name, bookName: this.bookName }})
      },
      changePage({current}){
        this.pagination.page = current
        this.getData()
      },
      // 考试大纲文件变化处理
      handleFileChange(info) {
        let fileList = [...info.fileList];
        fileList = fileList.slice(-1);
        fileList = fileList.map(file => {
          if (file.response) {
            file.url = file.response.url;
          }
          return file;
        });
        this.syllabusFileList = fileList;
        if (fileList.length > 0) {
          this.pdfFiles.exam_syllabus_name = fileList[0].name;
        }
      },
      
      // 考试大纲文件上传
      customRequestDetail(data) {
        let formData = new FormData();
        formData.append('file', data.file);
        uploadImg(formData).then(res => {
          this.syllabusFileList[0].status = 'done';
          this.pdfFiles.exam_syllabus = res.fileUrl;
          this.$message.success('考试大纲上传成功');
        }, error => {
          console.log(error);
          this.$message.error('上传失败，请重试');
        });
      },
      
      // 斩题精华文件变化处理
      handleEssenceChange(info) {
        let fileList = [...info.fileList];
        fileList = fileList.slice(-1);
        fileList = fileList.map(file => {
          if (file.response) {
            file.url = file.response.url;
          }
          return file;
        });
        this.essenceFileList = fileList;
        if (fileList.length > 0) {
          this.pdfFiles.question_essence_name = fileList[0].name;
        }
      },
      
      // 斩题精华文件上传
      customRequestEssence(data) {
        let formData = new FormData();
        formData.append('file', data.file);
        uploadImg(formData).then(res => {
          this.essenceFileList[0].status = 'done';
          this.pdfFiles.question_essence = res.fileUrl;
          this.$message.success('斩题精华上传成功');
        }, error => {
          console.log(error);
          this.$message.error('上传失败，请重试');
        });
      },
      setShow(index , id){
        this.loading = true
        http.show_course_book({id:id}).then(res=>{
          this.loading = false;
          this.result[index]['show'] = !this.result[index]['show'];
        }).catch(error=>{
          this.loading = false
          console.log(error)
        })
      },
      getData(){
        this.result = [];
        this.loading = true;
        let request= {
          ...this.filter,...this.pagination,
          user_id:this.$store.state.userInfo.id,
          cate_id: this.filter.cate_id
        }
        getVipQuestionList(request).then(res=>{
          this.loading = false
          // Process the list to set typeName based on type and v_type
          res.list.forEach(item => {
            this.setQuestionTypeName(item);
          });
          this.result = res.list
          this.total = res.total
          this.pagination.total = res.total
        },error=>{
          this.loading = false
          console.log(error)
        })
      },
      handleChange(value) {
        let parentType = this.getParentType(value)
        this.currentType = parentType;
        // Reset currentItem to a new object with just the type
        this.currentItem = {
          type: parentType,
          v_type: value,
          typeName: this.getTypeName(value)
        };
        this.visible = true;
        // Find the display name for the selected value
        for (const group of this.questionTypeGroups) {
          if (group.types[value]) {
            this.downEnroll = group.types[value];
            break;
          }
        }
      },
      getParentType(type) {
        if (this.questionTypeGroups[1].types[type]) {
          return 'answer';
        }
        return type;
      },
      getTypeName(type) {
        for (const group of this.questionTypeGroups) {
          if (group.types[type]) {
            return group.types[type];
          }
        }
        return '';
      },
      setQuestionTypeName(question) {
        const typeToCheck = question.v_type || question.type;
        let displayName = typeToCheck;
        for (const group of this.questionTypeGroups) {
          if (group.types[typeToCheck]) {
            displayName = group.types[typeToCheck];
            break;
          }
        }
        
        question.typeName = displayName;
        
        return displayName;
      },
      onSelectChange(){
  
      },
      editItem(record){
        this.currentItem = record
        this.visible = true
      },
      deleteItem(id){
        let _this = this
        this.$confirm({
          title: '删除后不可恢复，确认删除吗?',
          centered: true,
          onOk() {
            deleteVipQuestion({id}).then(res=>{
              _this.getData()
            },error=>{
              console.log(error)
            })
          },
        });
      },
      hideModal(){
  
      }
    }
  }
  </script>
  <style lang="less" scoped>
  </style>
  